import { Component } from '@angular/core';

@Component({
  templateUrl: './default-layout.component.html',
  standalone: false
})
export class DefaultLayoutComponent {

}
